export function bodyAutPlantilla() {
  return {
    documents: {
      "STATIC PLANTILLA Nuevo Contrato": {
        documentName: "##document##",
        documentLabel: "Label",
        documentB64: ``,
        block: 1,
        order: 1,
        mandatory: 1,
        transferible: 1,
        signmultiple: 1,
        signupload: 0,
        reference: "STATIC PLANTILLA Nuevo Contrato"
      }
    },
    signers: [
      {
        level: 1,
        order: 1,
        signerData: [
          // {
          //   identifier: "nif",
          //   value: "04618435N",
          //   authentication: "N",
          //   label: "NIF",
          //   resumen: "Y",
          //   order: 1,
          //   actions: []
          // },
          {
            identifier: "email",
            value: "##email##",
            authentication: "N",
            label: "Correo",
            resumen: "Y",
            order: 2,
            actions: [

              {
                className: "com.galeon.docsmanager.additionalactions.AdditionalActions",
                identifier: "sendConfirmationEmail",
                step: "FIRMA-FINAL"
              }
            ]
          },
          {
            identifier: "name",
            value: "##name##",
            authentication: "N",
            label: "Nombre",
            resumen: "Y",
            order: 3,
            actions: []
          },
          {
            identifier: "lastname",
            value: "##lastname##",
            authentication: "N",
            label: "Apellidos",
            resumen: "Y",
            order: 4,
            actions: []
          },
          {
            identifier: "cellphone",
            value: "##cellphone##",
            authentication: "N",
            label: "Telefono",
            resumen: "Y",
            order: 5,
            actions: []
          },
          {
            identifier: "idiomadef",
            value: "##idiomavalue##",
            authentication: "N",
            label: "Idioma",
            resumen: "N",
            order: 7,
            actions: []
          },          
          {
            identifier: "cajafirma",
            value: "firmante2",
            authentication: "N",
            label: "Caja de firma",
            resumen: "N",
            order: 6,
            actions: []
          }
          // {
          //   identifier: "smstemplate",
          //   value: "Galeon: el código para firmar es ##signotp##",
          //   authentication: "N",
          //   label: "SMS",
          //   resumen: "N",
          //   order: 7,
          //   actions: []
          // }
        ],
        signaturesType: ["SIMPLE"],
        docs: ["STATIC PLANTILLA Nuevo Contrato"]
      }
    ],
    operationData: [
      {
        identifier: "opClass",
        value: "1313",
        authentication: "N",
        label: "Operation",
        resumen: "Y",
        order: 8,
        actions: []
      }
    ]
  };
}
